import React, { Component } from 'react'
import { chain, map, noop } from 'lodash'
import { Trans } from '@lingui/macro'

import Tag from './Tag'

interface IState {
  expanded: boolean
}

interface ITag {
  id: number
  name: string
}
export interface IProps {
  expansionCutoff?: number
  items: ITag[]
  onClick?: (item: ITag) => void
  onRemove?: (item: ITag) => void
  allowFocus?: boolean
  size?: 'small' | 'normal' | 'large'
}

// TODO refactor to FC
export class Tags extends Component<IProps, IState> {
  static defaultProps = {
    expansionCutoff: 3,
    allowFocus: true,
    onClick: noop,
    size: 'normal'
  }

  state: IState = {
    expanded: false
  }

  toggleExpanded = () => {
    const { expanded } = this.state
    this.setState({ expanded: !expanded })
  }

  render() {
    const { expansionCutoff, items, onClick, onRemove, size, allowFocus } =
      this.props

    const { expanded } = this.state
    if (!items) {
      return null
    }
    const itemsToRender = chain(items)
      .sortBy(({ name }) => name)
      .take(expanded ? items.length : expansionCutoff)
      .value()

    // @ts-expect-error 9/11/2020
    const hiddenItems = items.length - expansionCutoff

    return (
      <>
        {map(itemsToRender, (item) => (
          <Tag
            key={item.id}
            size={size}
            tabIndex={allowFocus ? 0 : -1}
            onClickClose={onRemove && (() => onRemove(item))}
            onClick={(ev) => {
              ev.preventDefault()
              ev.stopPropagation()
              // @ts-expect-error 9/11/2020
              return onClick(item)
            }}
          >
            {item.name}
          </Tag>
        ))}
        {!expanded && hiddenItems > 0 && (
          <Tag
            color="clear"
            key="expand"
            tabIndex={allowFocus ? 0 : -1}
            size={size}
            onClick={(ev) => {
              ev.preventDefault()
              ev.stopPropagation()
              this.toggleExpanded()
            }}
          >
            +{hiddenItems} <Trans>more</Trans>
          </Tag>
        )}
      </>
    )
  }
}

export default Tags
